import { Email } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

function MailTo(props) {
  function getUniqueEmails(data) {
    if (!data || data.length === 0) {
      return '';
    }
    const emailArray = props.rawData
      ? props.data
      : data.map(item => item[props.filterKey || 'ActorEmail']);
    return Array.from(new Set(emailArray)).join('; ');
  }

  const emails = getUniqueEmails(props.data);

  return (
    <Tooltip title={`Send email to: ${emails.replace(/,/g, ', ')}`}>
      <IconButton
        component="a"
        href={`mailto:${emails}?subject=PECR ${props.pecrId} - ${props.title}`}
        sx={{
          color: '#1976d2',
          padding: '0px',
          minWidth: 'auto',
          minHeight: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          verticalAlign: 'middle',
          '&:hover': {
            color: '#115293',
            backgroundColor: 'rgba(25, 118, 210, 0.04)',
          },
        }}
        size="small"
        disabled={!emails}
      >
        <Email />
      </IconButton>
    </Tooltip>
  );
}

MailTo.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      ActorEmail: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  pecrId: PropTypes.string.isRequired,
  rawData: PropTypes.bool,
  filterKey: PropTypes.string,
};

export default MailTo;
